import type { SerializerOptions } from '@ember-data/legacy-compat';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type { ModelSchema } from '@ember-data/store/types';

import type { RecordAttributes, RecordData } from 'webapp-types';
import { omit } from 'webapp/utils/common';

import ApplicationSerializer from 'webapp/serializers/application';

import type ReportSlideFragmentRecord from 'webapp/models/report-slide-fragment';

export default class ReportSlideFragmentSerializer extends ApplicationSerializer {
	// json is Raw when it comes from BE, Serialized when BufferedModel.toJSON() runs a record through normalize
	override normalize(
		typeClass: ModelSchema,
		json: RecordData.ReportSlideFragment.Raw | RecordData.ReportSlideFragment.Serialized,
		prop: string | undefined,
	) {
		const { settings, ...data } = json;
		const attributes: Partial<RecordAttributes<ReportSlideFragmentRecord>> & {
			id?: string | number;
		} = { ...data };

		if (settings) {
			// undefined values are skipped by ED
			attributes.width = settings.width;
			attributes.height = settings.height;
		}

		return super.normalize(typeClass, attributes, prop);
	}

	override serialize(
		snapshot: Snapshot,
		options: SerializerOptions,
	): RecordData.ReportSlideFragment.Serialized {
		const attributes = super.serialize(
			snapshot,
			options,
		) as RecordAttributes<ReportSlideFragmentRecord>;

		const settings: RecordData.ReportSlideFragment.Settings = {};
		if (attributes.width) {
			settings.width = attributes.width;
		}
		if (attributes.height) {
			settings.height = attributes.height;
		}

		return {
			...omit(attributes, 'width', 'height', 'isNewlyCreated'),
			settings,
		};
	}
}
